import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import parameters, {
	type planSelectionPageModalQuery,
} from './__generated__/planSelectionPageModalQuery.graphql';
import type { PlanSelectionPageModalType } from './plan-selection-page-modal';

export type EntryPointParams = {
	cloudId: string;
	hamsProductKey: string;
	/**
	 * When true, the modal preloads the GUPS profile data used to decide whether the
	 * "Contact sales" message should be shown (twcg-1533-pls-contact-path-disco).
	 */
	shouldCheckContactSalesEligibility?: boolean;
	/** The Atlassian account id of the current user */
	userId?: string | null;
};

type PlanSelectionPageModalComponent = EntryPointComponent<
	{
		planSelectionPageModalQuery: planSelectionPageModalQuery;
	},
	Record<string, never>,
	{
		onClose: () => void;
		type: PlanSelectionPageModalType;
	},
	Record<string, never>
>;

export const entryPoint: EntryPoint<PlanSelectionPageModalComponent, EntryPointParams> =
	createEntryPoint({
		root: JSResourceForInteraction<PlanSelectionPageModalComponent>(
			/* webpackChunkName: "@atlaskit-internal_edition-awareness-plan-selection-page-modal" */ './plan-selection-page-modal',
			{
				moduleId: 'edition-awareness-plan-selection-page-modal',
			},
		),
		getPreloadProps: ({
			cloudId,
			hamsProductKey,
			shouldCheckContactSalesEligibility = false,
			userId,
		}: EntryPointParams) => ({
			entryPoints: {},
			extraProps: {},
			queries: {
				planSelectionPageModalQuery: {
					parameters,
					variables: {
						cloudId,
						hamsProductKey,
						shouldCheckContactSalesEligibility,
						// The GUPS fields are skipped when eligibility isn't being checked, so the
						// required $userId variable is satisfied with a placeholder
						userId: userId ?? '',
					},
				},
			},
		}),
	});
